import { Component } from '@angular/core';
import { TWorkspaceSimpleResponse } from '@project/view-models';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { TDropdown } from 'src/app/project/components/dropdown/dropdown.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TUserSettingsSitesDropdownModalData } from './user-settings-sites-dropdown-consts';
import { UserSettingsSitesDropdownService } from './user-settings-sites-dropdown.service';

@Component({
    selector: 'pp-user-settings-sites-dropdown',
    templateUrl: './user-settings-sites-dropdown.component.html',
    styleUrl: './user-settings-sites-dropdown.component.scss',
    standalone: false
})
export class UserSettingsSitesDropdownComponent {
  EIconPath = EIconPath;
  allWorkspacesVisible: boolean;

  private workspaces: TWorkspaceSimpleResponse[] = [];
  private dropdown: TDropdown<TUserSettingsSitesDropdownModalData>;

  constructor(
    private dropdownService: DropdownService,
    private userSettingsSitesDropdownService: UserSettingsSitesDropdownService,
  ) {
    this.dropdown = this.dropdownService.getDropdown();
    this.setData();
  }

  toggleBulkHidden(): void {
    if (!this.allWorkspacesVisible) {
      this.userSettingsSitesDropdownService.showAllSites().subscribe((shares) => {
        this.dropdown.callback(shares);
        this.hideDropdown();
      });
    } else {
      this.userSettingsSitesDropdownService.hideAllSites().subscribe((shares) => {
        this.dropdown.callback(shares);
        this.hideDropdown();
      });
    }
  }

  toggleBulkDigestSettings(): void {
    this.userSettingsSitesDropdownService.showBulkDigestModal();
    this.hideDropdown();
  }

  private setData(): void {
    const data: TUserSettingsSitesDropdownModalData = this.dropdown.data;

    if (!data) {
      return;
    }

    this.workspaces = data.workspaces;
    this.allWorkspacesVisible = this.workspaces.every((workspace) => !workspace.hidden);
  }

  private hideDropdown(): void {
    this.dropdownService.hideDropdown();
  }
}
